<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item >
			<template slot="label">
				<i class="el-icon-office-building"></i>
				本人是否是残疾人
			</template>
			<el-tag :type="biao.is_me==0?'success':'danger'">{{biao.is_me==0?"是":'否'}}</el-tag>
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.type">
			<template slot="label">
				<i class="el-icon-paperclip"></i>
				家庭类型
			</template>
			{{biao.type}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.school_ori">
			<template slot="label">
				毕业学校
			</template>
			{{biao.school_ori}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.school">
			<template slot="label">
				就读学校
			</template>
			{{biao.school}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.zhuanye">
			<template slot="label">	
				当前年级
			</template>
			{{biao.zhuanye}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.edu">
			<template slot="label">	
				学历层次
			</template>
			{{biao.edu}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.gaokao_fenshu">
			<template slot="label">	
				申请年度
			</template>
			{{biao.gaokao_fenshu}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.xuezhi">
			<template slot="label">	
				学制
			</template>
			{{biao.xuezhi}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.zhuanye">
			<template slot="label">
				银行卡号
			</template>
			{{biao.yhcard}}
		</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			cjtypes(){
				
				return this.biao.cjtypes;
			}
			
		},
		watch:{
			biao(){
			  	
			}
		},
		props:["biao"],
		created() {
			
		}
	}
</script>

<style>
</style>
